import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { defaultLanguage, resources, supportedLanguages } from './languages';

i18n
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: supportedLanguages.map((l) => l.code),
    lng: localStorage.getItem('language') || defaultLanguage,
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;

